import { ref, onMounted } from 'vue';
import { useAxios } from '@vueuse/integrations/useAxios';

import { lockRefresh, unlockRefresh } from '@/services/utils';

export function useUpload() {
  const uploading = ref(false);

  const progress = ref(0);
  const progressCallback = ref(null);
  const onProgress = function (callback) {
    progressCallback.value = callback;
  };

  const error = ref(null);
  const errorCallback = ref(null);
  const onError = function (callback) {
    errorCallback.value = callback;
  };

  const result = ref(null);
  const onDoneCallback = ref(null);
  const onDone = function (callback) {
    onDoneCallback.value = callback;
  };

  async function upload(signedUrl, file) {
    const uploadId = `${Math.random()}`;
    lockRefresh(uploadId);
    uploading.value = true;
    const { execute } = useAxios(
      signedUrl,
      {
        method: 'PUT',
        onUploadProgress: (progressEvent) => {
          progress.value = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          if (progressCallback.value) {
            progressCallback.value(progress.value);
          }
        },
      },
      {
        immediate: false,
      }
    );

    try {
      const response = await execute({ data: file });
      if (response.isFinished.value === true) {
        result.value = response;
        if (onDoneCallback.value) {
          return onDoneCallback.value(response);
        } else {
          return result.value;
        }
      }
    } catch (err) {
      error.value = err;
      if (errorCallback.value) {
        return errorCallback.value(err);
      } else {
        throw err;
      }
    } finally {
      uploading.value = false;
      unlockRefresh(uploadId);
    }
  }

  onMounted(() => {
    window.onbeforeunload = function () {
      if (uploading.value) {
        return 'There is unsaved data.';
      }
      return undefined;
    };
  });

  return {
    upload,
    uploading,
    progress,
    onProgress,
    result,
    onDone,
    error,
    onError,
  };
}
